import {
    ChangeDetectorRef,
    Component,
    ElementRef, EventEmitter,
    HostBinding,
    Input, Output, QueryList,
    Renderer, ViewChildren
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { isDefined } from "ionic-angular/util/util";
import { ControlInlined } from "../../business-objects/control/control.model";
import { ControlType } from "../../business-objects/control-type/control-type.model";
import { Form } from "../../business-objects/form/form.model";
import { Config, Form as IonicForm, Item } from "ionic-angular";
import { CONTROL_TYPES } from "../../controls/control-types";
import { classesObjectToString } from "../../../core/helpers/classes-object-to-string";
import { ControlConfigDirection } from "../../business-objects/control/control-config.model";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { ControlComponent } from "../../controls/control.component";
import { IonicFormInput } from "ionic-angular/util/form";
import { FieldWrapperKeyboardController } from "./field-wrapper-keyboard.controller";
import { ControlComponentAdaptor } from "./control-component-adaptor";
import { Subject } from "rxjs/Subject";
import { FieldWrapperKeyboardTabEvent } from "./events/field-wrapper-keyboard-tab-event";

export interface IFieldWrapperComponentInputs {
    formGroup: FormGroup;
    form: Form;
    xformControl: FormControl;
    definition: ControlInlined;
    assetId: string;
}

@Component({
    selector: "field-wrapper",
    template: `
        <div class="item-inner" (keydown.tab)="onHandleTab($event, false)"
             (keydown.shift.tab)="onHandleTab($event, true)">
            <div class="input-wrapper">
                <ion-label
                    [hidden]="!showLabel"
                    [attr.for]="definition.name"
                    [ngClass]="'field-type-' + definition.controlType.name + '-label'"
                ><span *ngIf="required">*</span>{{definition.title}}</ion-label>


                <ng-container [ngSwitch]="getControlTypeName()" *ngIf="!!xformControl">
                    <div class="errorMessage" *ngIf="!xformControl">Control not found for {{ definition.name }}</div>
                    <text-control
                        *ngSwitchCase="'text'"
                        [ngClass]="getFieldClass()"
                        [formControl]="xformControl"
                        [definition]="definition"
                        #control
                    ></text-control>

                    <ion-input
                        *ngSwitchCase="'password'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        type="password"
                        mytabindex
                        autocomplete="off"
                        #control
                    ></ion-input>

                    <reglookup-field
                        *ngSwitchCase="'reglookup'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [formGroup]="formGroup"
                        [definition]="definition"
                        mytabindex
                        #control
                    ></reglookup-field>

                    <ion-input
                        *ngSwitchCase="'email'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [type]="definition.controlType"
                        #control
                    ></ion-input>

                    <complex-field
                        *ngSwitchCase="'complex'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formGroup]="formGroup"
                        [form]="form"
                        [control]="xformControl"
                        [definition]="definition"
                        item-content
                        #control
                    ></complex-field>

                    <listpicker
                        *ngSwitchCase="'list'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [definition]="definition"
                        [form]="formGroup"
                        item-content
                        #control
                    ></listpicker>

                    <userlistpicker
                        *ngSwitchCase="'userlist'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [definition]="definition"
                        [form]="formGroup"
                        item-content
                        #control
                    ></userlistpicker>

                    <acl-category
                        *ngSwitchCase="'aclcategory'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [definition]="definition"
                        [formGroup]="formGroup"
                        [assetId]="assetId"
                        item-content
                        #control
                    ></acl-category>

                    <richtext
                        *ngSwitchCase="'richtext'"
                        [formGroup]="formGroup"
                        [formControl]="xformControl"
                        [definition]="definition"
                        item-content
                        #control
                    ></richtext>

                    <ion-select
                        *ngSwitchCase="'select'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [multiple]="getOption('multi')"
                        #control
                    >
                        <ion-option *ngFor="let opt of getOption('options')" [value]="opt.value">{{opt.title}}
                        </ion-option>
                    </ion-select>

                    <toggle
                        *ngSwitchCase="'toggle'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [definition]="definition"
                        #control
                    ></toggle>

                    <contact
                        *ngSwitchCase="'contact'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [definition]="definition"
                        #control
                    ></contact>

                    <vas-datepicker
                        *ngSwitchCase="'datetime'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [definition]="definition"
                        item-content
                        #control
                    ></vas-datepicker>

                    <membership
                        *ngSwitchCase="'membership'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formGroup]="formGroup"
                        [formControl]="xformControl"
                        [definition]="definition"
                        item-content
                        #control
                    ></membership>

                    <splat *ngSwitchCase="'splat'"
                           [ngClass]="definition.name.replace('.', '-')"
                           [formControl]="xformControl"
                           [definition]="definition"
                           item-content
                           #control
                    ></splat>

                    <passalertfail
                        *ngSwitchCase="'passalertfail'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [definition]="definition"
                        item-content
                        #control
                    ></passalertfail>

                    <fee-field
                        *ngSwitchCase="'fee'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [formGroup]="formGroup"
                        [definition]="definition"
                        #control
                    ></fee-field>

                    <checkboxlist-field
                        *ngSwitchCase="'checkboxlist'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [formGroup]="formGroup"
                        [definition]="definition"
                        #control
                    ></checkboxlist-field>

                    <vas-costs-field
                        *ngSwitchCase="'costs'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [formGroup]="formGroup"
                        [definition]="definition"
                        #control
                    ></vas-costs-field>

                    <select-contact
                        *ngSwitchCase="'selectcontact'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [form]="form"
                        [formGroup]="formGroup"
                        [definition]="definition"
                        item-content
                        #control
                    ></select-contact>

                    <vas-textarea
                        *ngSwitchCase="'textarea'"
                        [ngClass]="definition.name.replace('.', '-')"
                        [formControl]="xformControl"
                        [formGroup]="formGroup"
                        [definition]="definition"
                        item-content
                        #control
                    ></vas-textarea>
                </ng-container>
            </div>
        </div>
    `,
    viewProviders: [
        FieldWrapperKeyboardController
    ]
})
export class FieldWrapperComponent extends Item implements IFieldWrapperComponentInputs {
    /**
     * If you change any of these inputs make sure you:
     * 1) make the same changes to the IFieldWrapperComponentInputs interface, and
     * 2) update fields/complex/complex-control.component.ts because it dynamically creates this component
     */
    @Input() formGroup: FormGroup;
    @Input() form: Form;
    @Input() xformControl: FormControl; // we can't name it 'formControl' coz it breaks shit
    @Input() definition: ControlInlined;
    @Input() assetId: string;

    @Output() tabExitBackwards: EventEmitter<FieldWrapperKeyboardTabEvent> = new EventEmitter<FieldWrapperKeyboardTabEvent>();
    @Output() tabExitForwards: EventEmitter<FieldWrapperKeyboardTabEvent> = new EventEmitter<FieldWrapperKeyboardTabEvent>();

    @ViewChildren("control") controlComponents: QueryList<ControlComponent | IonicFormInput>;

    @HostBinding("class") hostClass = "";
    @HostBinding("style.display") display: string;

    protected ngUnsubscribe: Subject<void> = new Subject<void>();

    controlTypes: Array<ControlType>;

    constructor(form: IonicForm,
                config: Config,
                elementRef: ElementRef,
                renderer: Renderer,
                protected ref: ChangeDetectorRef,
                protected appFacade: VasAppFacade,
                protected keyboardController: FieldWrapperKeyboardController) {
        super(form, config, elementRef, renderer, undefined as any);
    }

    get required(): boolean {
        return this.definition.validators && this.definition.validators.indexOf("required") !== -1;
    }

    get showLabel(): boolean {
        return this.getOption("showLabel", true);
    }

    ngOnInit(): void {

        if (!this.form) {
            throw Error("@Input form is required");
        }

        if (!this.formGroup) {
            throw Error("@Input formGroup is required");
        }

        this.appFacade.objects.controlType.store
            .getAll()
            .take(1)
            .subscribe(list => this.controlTypes = list);

        this.hostClass = this.getHostClass();
        this.display = this.definition.controlType.name !== CONTROL_TYPES.HIDDEN ? "block" : "none";

        this.keyboardController.exitBackwards
            .takeUntil(this.ngUnsubscribe)
            .subscribe($event => this.tabExitBackwards.next(new FieldWrapperKeyboardTabEvent($event, this)));

        this.keyboardController.exitForwards
            .takeUntil(this.ngUnsubscribe)
            .subscribe($event => this.tabExitForwards.next(new FieldWrapperKeyboardTabEvent($event, this)));
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    onHandleTab($event: KeyboardEvent, shift: boolean = false): boolean {
        return this.keyboardController.handleTabEvent($event, shift, this.getControlComponent());
    }

    getOption(key: string, defaultValue?): any {

        if (!isDefined(this.definition.config) || !isDefined(this.definition.config[key]) || this.definition.config[key] === null) {
            return defaultValue;
        }

        return this.definition.config[key];
    }

    getHostClass(): string {

        const classes = {
            item: true,
            "item-block": true,
            "item-md": true,
            "item-input": true,
            [`field-type-${this.getControlTypeName()}`]: true,
            [`field-name-${this.getFieldName().replace(".", "-")}`]: true,
            "direction-row": this.getOption("direction", ControlConfigDirection.ROW.toString()) === ControlConfigDirection.ROW.toString(),
            "direction-column": this.getOption("direction", ControlConfigDirection.ROW.toString()) === ControlConfigDirection.COLUMN.toString()
        };

        return classesObjectToString(classes);
    }

    getFieldClass(): string {
        return this.definition.name.replace(".", "-");
    }

    getControlTypeName(): string {
        return this.definition.controlType.name;
    }

    getFieldName(): string {
        return this.definition.name;
    }

    focus(): void {
        this.getControlComponent().focus();
    }

    protected getControlComponent(): ControlComponentAdaptor {

        if (!this.controlComponents || this.controlComponents.length === 0) {
            return new ControlComponentAdaptor();
        }

        return new ControlComponentAdaptor(this.controlComponents.first);
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/field-wrapper/field-wrapper.component.ts